import { useRef, useState } from "react";
import HelmetTags from "../../../MainComponents/HelmetTags";
import useFade from "../../../MainComponents/Hooks/useFade";
import useAxios from "../../../MainComponents/Hooks/useAxios";
import dayjs from "dayjs";
import { Row, Col, Select, Spin, Tag, Empty } from "antd";

const { Option } = Select;

export const Purchases = () => {
  const TitleWrapper = useRef();
  const [fade] = useFade(TitleWrapper, 100);

  const [filterType, setFilterType] = useState("all");

  const [purchasesData, purchasesErrors, purchasesLoading] = useAxios(
    `${process.env.REACT_APP_STUDENT_ORDERS_API}?type=${filterType}`,
    "GET",
    "GET",
    filterType
  );

  return (
    <section className="width mb-32 min-h-screen dark:bg-dark dark:text-light">
      <HelmetTags title="My Purchases | Mr Ibrahim Abdel Masseh" />

      <div ref={TitleWrapper} className="title-wrapper mt-36 mb-8">
        <h2
          className={`mb-4 text-center text-5xl font-bold transition-all duration-300 ease-linear ${
            fade ? "translate-y-14 opacity-0" : "translate-y-0 opacity-100"
          }`}
        >
          My Purchases
        </h2>

        {/* === Filter === */}
        <div className="flex justify-center">
          <Select
            defaultValue={filterType}
            onChange={(value) => setFilterType(value)}
            className="w-64"
          >
            <Option value="all">All</Option>
            <Option value="paid">Paid</Option>
            <Option value="pending">Pending</Option>
            <Option value="failed">Failed</Option>
          </Select>
        </div>
      </div>

      {purchasesLoading && (
        <div className="text-center my-12">
          <Spin size="large" />
        </div>
      )}

      {purchasesErrors && (
        <p className="text-red-500 text-center">
          Error loading purchases. Please try again.
        </p>
      )}

      {!purchasesLoading && purchasesData?.data?.length === 0 && (
        <Empty description="No purchases found." className="my-12" />
      )}

      <Row gutter={[16, 16]}>
        {purchasesData?.data?.map((order) => (
          <Col key={order.id} xs={24} sm={12} md={8} lg={6}>
            <div className="rounded-2xl border p-4 shadow hover:shadow-lg transition duration-300 dark:border-gray-700">
              <h3 className="mb-2 text-3xl font-semibold">
                {order.lecture}
              </h3>


              <p className="mb-1">
                Amount:{" "}
                <span className="font-bold text-green-600">
                  ${order.amount}
                </span>
              </p>

              <p className="mb-1">
                Date: {dayjs(order.created_at).format("DD MMM YYYY, hh:mm A")}
              </p>

              <p>
                Status:{" "}
                <Tag
                  color={
                    order.payment_status === "paid"
                      ? "green"
                      : order.payment_status === "pending"
                        ? "gold"
                        : "red"
                  }
                >
                  {order.payment_status}
                </Tag>
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </section>
  );
};
